import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { map } from 'rxjs/operators';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import {
  REFRESH_URL,
  VIEW_NAME,
  WIFI_IDENTIFICATION_PATH
} from '../../constants/login-constant';
import { ResetPasswordUserResponse } from '../../models/reset-password-api.interface';
import { NextDisplayViewService } from '../next-display-view.service';

@Injectable({
  providedIn: 'root'
})
export class WifiPortalService {
  refreshURL!: string;
  noSQA!: boolean;
  lockSQA!: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private nextDisplayViewService: NextDisplayViewService,
    private analytics: AnalyticsService
  ) {}

  /* Get query params App ID for DPP flow */
  getQueryParamsWFP(): { isWFP: boolean; login_app_ID_WFP: string } {
    let login_app_ID_WFP = '';
    let isWFP = false;
    this.activatedRoute.queryParamMap
      .pipe(map((params: ParamMap) => params.get('login_appID')))
      .subscribe((query) => {
        login_app_ID_WFP = query ?? '';
        isWFP = login_app_ID_WFP === 'WFP';
      });
    return {
      isWFP,
      login_app_ID_WFP
    };
  }

  /* Get query params Refresh URL for DPP flow redirect */
  getRefreshUrlWFP(value?: boolean): void {
    this.activatedRoute.queryParamMap
      .pipe(map((params: ParamMap) => params.get(REFRESH_URL)))
      .subscribe((query) => {
        this.refreshURL = query ?? '';
        if (value) {
          this.identificationRedirect();
        }
      });
  }

  isNoSecurityQuestionAnswer(value: boolean) {
    this.noSQA = value;
  }

  isSecurityQuestionLocked(value: boolean) {
    this.lockSQA = value;
  }

  identificationRedirect(): void {
    if (this.noSQA || this.lockSQA) {
      this.refreshURL = `${this.refreshURL}${WIFI_IDENTIFICATION_PATH}`;
      window.location.assign(this.refreshURL);
    }
  }

  handleWifiPortalNoSecurityQuestion(response: ResetPasswordUserResponse) {
    if (this.getQueryParamsWFP().isWFP && response.hasSQA === false) {
      this.isNoSecurityQuestionAnswer(true);
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.RECOVERY_ACCOUNT_LOADED,
        true
      );
      this.nextDisplayViewService.nextDisplayView(
        VIEW_NAME.RECOVER_ACCOUNT_SCREEN
      );
      return true;
    }
    return false;
  }
}
